const videosConstants = {
    ALLOWED_VIDEO_TYPES: { "video/mp4": [".mp4"] },
    MAX_SIZE: 50000000,
    MAX_FILES: 5,
}

export default videosConstants